import { useAuth } from '../../context/AuthContext';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';
import { getNavItems } from './navConfig';
import './layout.css';

/**
 * Shell compartido por todos los dashboards: header + contenido + nav
 * inferior. La navegación y el acento de color se derivan del rol del
 * usuario autenticado, así cada vista solo debe preocuparse de su
 * `title`/`subtitle`/contenido.
 *
 * @param {{ title: string, subtitle?: string, children: React.ReactNode }} props
 */
export default function DashboardLayout({ title, subtitle, children }) {
  const { user } = useAuth();
  const navItems = getNavItems(user?.role);

  return (
    <div className="pulso-shell" data-role={user?.role}>
      <AppHeader title={title} subtitle={subtitle} />
      <main className="pulso-shell__content">{children}</main>
      <BottomNav items={navItems} />
    </div>
  );
}
